import { PartFinderReport } from '@/api/generatedApi';
import { CopiableGridColDef } from '@/types/copiableColumn';
import { getCreatorEmailValue } from '@/utils/dataGridValueGetters';
import { format } from 'date-fns';
import { getReportElapsedLabel } from './reportElapsedTime';
import {
  RenderCreatedAt,
  RenderCreator,
  RenderDescription,
  RenderElapsed,
  RenderPartNumber,
  RenderReportThumbnail,
  RenderStatus,
  RenderTopRecommendation,
} from './cellDefinitions';

export const partFinderThumbnailColumn: CopiableGridColDef<PartFinderReport> = {
  field: 'thumbnail',
  headerName: '',
  width: 63,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: RenderReportThumbnail,
};

export const partFinderReportColumns: CopiableGridColDef<PartFinderReport>[] = [
  {
    field: 'partNumber',
    headerName: 'Part Number',
    width: 180,
    flex: 1,
    renderCell: RenderPartNumber,
    getCopyValue: row => row.partNumber,
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 2,
    minWidth: 200,
    renderCell: RenderDescription,
    getCopyValue: row => row.description,
  },
  {
    field: 'topRecommendation',
    headerName: 'Top Recommendation',
    flex: 2,
    minWidth: 240,
    renderCell: RenderTopRecommendation,
    getCopyValue: row => row.finalRecommendation ?? row.aiSuggestedRecommendation,
  },
  {
    field: 'creator',
    headerName: 'Created By',
    width: 130,
    flex: 1,
    renderCell: RenderCreator,
    valueGetter: getCreatorEmailValue,
    getCopyValue: row => row.creator?.email,
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    width: 120,
    flex: 1,
    renderCell: RenderCreatedAt,
    getCopyValue: row => (row.createdAt ? format(new Date(row.createdAt), 'MMM d, yyyy') : undefined),
  },
  {
    field: 'elapsed',
    headerName: 'Elapsed',
    width: 100,
    sortable: false,
    renderCell: RenderElapsed,
    getCopyValue: row => getReportElapsedLabel(row, Date.now()),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    flex: 1,
    renderCell: RenderStatus,
    getCopyValue: row => row.status,
  },
];
